import { render, staticRenderFns } from "./MobileVersion.vue?vue&type=template&id=3fe516e9&"
import script from "./MobileVersion.vue?vue&type=script&lang=js&"
export * from "./MobileVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports